import { observer } from 'mobx-react';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { useStore } from '../../contexts/store-provider';
import { redirectToDefaultRoute } from '../../helpers/route-helper';

const LoginLayout: React.FC<any> = (props) => {
  const { authStore } = useStore();
  const { isAuthenticated } = authStore;
  const getToken: any = localStorage.getItem('oms_token');
  return (
    <React.Fragment>
      {!isAuthenticated && (getToken == null || getToken == '') ? (
        props.children
      ) : (
        <Redirect to={redirectToDefaultRoute()} />
      )}
    </React.Fragment>
  );
};
export default observer(LoginLayout);
